import React, { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/Graphs/Select";
import ProgramOverview from "./ProgramOverview";
import { FlatCard } from "components/UI-lib";
import { AcademicCapIcon } from "@heroicons/react/24/solid";
import { useQuery } from "@tanstack/react-query";
import agent from "server";
import { Spinner } from "@kui-react/spinner";
import { Program } from "../types";

const Programs: React.FC = () => {
  const [programs, setPrograms] = useState<{ label: string; value: Program }[]>([]);
  const [selectedProgram, setSelectedProgram] = useState<Program | null>(null);

  const { data: programData, isLoading: programsLoading } = useQuery({
    queryKey: ["programs"],
    queryFn: () => agent.Admin.listPrograms(),
  });

  useEffect(() => {
    if (programData) {
      setPrograms(programData.data.map((program) => ({ label: program.displayName, value: program })));
    }
  }, [programData]);

  const onValueChange = (value: string) => {
    setSelectedProgram(
      programs.find((program) => program.value.id === value)?.value || null
    );
  };

  if (programsLoading) {
    return <Spinner className="pt-5" />;
  }

  return (
    <div className="flex flex-col min-h-[50vh] pt-5 ml-24 mr-24">
      <div className="flex flex-row justify-between">
        <h1 className="text-3xl font-bold mb-2 text-white">Programs</h1>
        <div className="flex flex-col w-[400px]">
          <Select onValueChange={onValueChange}>
            <SelectTrigger
              id="size"
              className="h-[38px] dark:border-borderPrimary"
            >
              <SelectValue placeholder="Select Program" />
            </SelectTrigger>
            <SelectContent>
              {programs.map((program) => (
                <SelectItem key={program.value.id} value={program.value.id}>
                  {program.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <hr className="w-[100%] my-3 dark:border dark:border-zinc-800" />
      {selectedProgram ? (
        <div className="mt-3">
          <ProgramOverview
            program={selectedProgram}
          />
        </div>
      ) : (
        <FlatCard className="text-sm text-gray-700 dark:text-secondary">
          <div className="flex flex-col items-center">
            <AcademicCapIcon className="w-6 h-6" />
            Select a program to display details
          </div>
        </FlatCard>
      )}
    </div>
  );
};

export default Programs;
